define('commons/diagnostic',['jquery', 'commons/loading-mask', 'commons/feedback-button', 'commons/monitoring/diagnostic-monitoring', 'commons/monitoring/diagnostic-hopping-monitoring', 'commons/message-manager'], function($, LoadingMask, FeedbackButton, DiagnosticMonitoring, DiagnosticHoppingMonitoring, messages) {

            var Diagnostic = function(options) {

                this.routeUrl = location.protocol + '//' + location.host + '/ws/route/diagnostic/';
                this.protocol = 'diagnostic';
                this.baseFreq = 0;
                this.refresh = true;
                this.hoppingEnding = false;

                this.options = $.extend(true, {
                    tapHexId: '',
                    waterfall: null,
                    step: 10000,
                    downlinkEnabled: false,
                    meanSpecSup: 0,
                    internalAllowed: false
                }, options);

                this.routeUrl += this.options.tapHexId;
                this.$parent = $('#diagnostic-commands #set-btns');
                this.loadingMask = new LoadingMask(this.$parent, {
                    maskColor: '#000',
                    iconColor: 'white',
                    progress: false
                });
                this.loadingMaskMode = new LoadingMask($('#diagnostic-commands #diagnostic-start'), {
                    maskColor: '#000',
                    iconColor: 'white',
                    progress: false
                });
                this.started = false;
                this.buttons = {};

                // start and stop diagnostic mode
                this.buttons.startDiagnostic = new FeedbackButton('button#diagnostic-start', {
                    defaultIconClasses: '',
                    onClick: $.proxy(function(event) {
                        if (!$(this.loadingMaskMode.mask).is(":visible")) {
                            if (!this.started) {
                                if (confirm("The station will enter diagnostic mode.\nStation in diagnostic mode cannot be edited")) {
                                    this.ws.send(JSON.stringify({
                                        key: 'setmode',
                                        args: {
                                            'mode': false
                                        }
                                    }));
                                    this.buttons.startDiagnostic.running();
                                }
                            } else {
                                this.ws.send(JSON.stringify({
                                    key: 'setmode',
                                    args: {
                                        'mode': true
                                    }
                                }));
                                this.buttons.startDiagnostic.running();
                            }
                            return true;
                        } else {
                            return false;
                        }
                    }, this),
                    withSuccessFeedback: false,
                    withErrorFeedback: false,
                });

                // Launch command through web socket
                this.buttons.radioFreq = new FeedbackButton('button#freq-btn', {
                    defaultIconClasses: '',
                    onClick: $.proxy(function(event) {
                        $('.btn-form:not("#freq-btn-form")').slideUp();
                        $('#freq-btn-form').slideToggle();
                        return true;
                    }, this),
                    withSuccessFeedback: false,
                    withErrorFeedback: false
                });
                $('#freq-btn-validate').on('click', $.proxy(function() {
                    $('#freq-btn-form').slideUp();
                    var args = $('.freq-btn-args').map(function(idx, elem) {
                        return $(elem).val();
                    }).get();
                    // valid frequency
                    if (isNaN(parseInt(args[0], 10)) || args[0] % 1 !== 0) {
                        this.buttons.radioFreq.error('Freq must be a valid integer');
                    } else {
                        this.baseFreq = parseInt(args[0], 10);
                        this.ws.send(JSON.stringify({
                            key: 'radio_freq',
                            args: {
                                'baseFrequency': parseInt(args[0], 10)
                            }
                        }));
                        this.buttons.radioFreq.running();
                    }
                }, this));

                this.buttons.radioHopping = new FeedbackButton('button#hopping-btn', {
                    defaultIconClasses: '',
                    onClick: $.proxy(function(event) {
                        $('.btn-form:not("#hopping-btn-form")').slideUp();
                        $('#hopping-btn-form').slideToggle();
                        return true;
                    }, this),
                    withSuccessFeedback: false,
                    withErrorFeedback: false
                });
                $('#hopping-btn-validate').on(
                        'click',
                        $.proxy(function() {
                            var args = $('.hopping-btn-args').map(function(idx, elem) {
                                return $(elem).val();
                            }).get();
                            // valid params
                            if (isNaN(parseInt(args[1], 10)) || args[1] % 1 !== 0 || isNaN(parseInt(args[2], 10)) || args[2] % 1 !== 0 ||
                                    isNaN(parseInt(args[3], 10)) || args[3] % 1 !== 0 || isNaN(parseInt(args[4], 10)) || args[4] % 1 !== 0) {
                                this.buttons.radioHopping.error('All parameters must be valid integers');
                            } else if (args[4] < 5) {
                                this.buttons.radioHopping.error('Time step must be at least 5 seconds');
                            } else if (args[1] >= args[2]) {
                                this.buttons.radioHopping.error('Stop frequency must be greater than start frequency');
                            } else {
                                this.ws.send(JSON.stringify({
                                    key: 'radio_hopping',
                                    args: {
                                        'set': args[0] === 'true',
                                        'start': parseInt(args[1], 10),
                                        'stop': parseInt(args[2], 10),
                                        'inc': parseInt(args[3], 10),
                                        'tinc': parseInt(args[4], 10)
                                    }
                                }));
                                this.buttons.radioHopping.running();
                            }
                        }, this));

                this.buttons.radioPreamp1 = new FeedbackButton('button#preamp1-btn', {
                    defaultIconClasses: '',
                    onClick: $.proxy(function(event) {
                        $('.btn-form:not("#preamp1-btn-form")').slideUp();
                        $('#preamp1-btn-form').slideToggle();
                        return true;
                    }, this),
                    withSuccessFeedback: false,
                    withErrorFeedback: false
                });
                $('#preamp1-btn-validate').on('click', $.proxy(function() {
                    $('#preamp1-btn-form').slideUp();
                    var args = $('.preamp1-btn-args').map(function(idx, elem) {
                        return $(elem).val();
                    }).get();
                    this.ws.send(JSON.stringify({
                        key: 'radio_preamp1',
                        args: {
                            'preamp': args[0]
                        }
                    }));
                    this.buttons.radioPreamp1.running();
                }, this));

                this.buttons.radioPreamp2 = new FeedbackButton('button#preamp2-btn', {
                    defaultIconClasses: '',
                    onClick: $.proxy(function(event) {
                        $('.btn-form:not("#preamp2-btn-form")').slideUp();
                        $('#preamp2-btn-form').slideToggle();
                        return true;
                    }, this),
                    withSuccessFeedback: false,
                    withErrorFeedback: false
                });
                $('#preamp2-btn-validate').on('click', $.proxy(function() {
                    $('#preamp2-btn-form').slideUp();
                    var args = $('.preamp2-btn-args').map(function(idx, elem) {
                        return $(elem).val();
                    }).get();
                    this.ws.send(JSON.stringify({
                        key: 'radio_preamp2',
                        args: {
                            'preamp': args[0]
                        }
                    }));
                    this.buttons.radioPreamp2.running();
                }, this));

                this.buttons.radioLna = new FeedbackButton('button#lna-btn', {
                    defaultIconClasses: '',
                    onClick: $.proxy(function(event) {
                        $('.btn-form').slideUp();
                        var arg = $('.lna-btn-args').first().val();
                        this.ws.send(JSON.stringify({
                            key: 'radio_lna',
                            args: {
                                'set': arg === "true"
                            }
                        }));
                        return true;
                    }, this),
                    withSuccessFeedback: false,
                    withErrorFeedback: false
                });

                this.buttons.rebootGateway = new FeedbackButton('button#rebootgateway-btn', {
                    defaultIconClasses: '',
                    onClick: $.proxy(function(event) {
                        $('.btn-form').slideUp();
                        this.ws.send(JSON.stringify({
                            key: 'reboot_gateway',
                            args: {}
                        }));
                        return true;
                    }, this),
                    withSuccessFeedback: false,
                    withErrorFeedback: false
                });

                this.buttons.radioGetRos = new FeedbackButton('button#getros-btn', {
                    defaultIconClasses: '',
                    onClick: $.proxy(function(event) {
                        $('.btn-form:not("#getros-btn-form")').slideUp();
                        $('#getros-btn-form').slideToggle();
                        return true;
                    }, this),
                    withSuccessFeedback: false,
                    withErrorFeedback: false
                });
                $('#getros-btn-validate').on('click', $.proxy(function() {
                    this.ws.send(JSON.stringify({
                        key: 'radio_getros',
                        args: {}
                    }));
                    this.buttons.radioGetRos.running();
                }, this));
                if (!this.options.downlinkEnabled) {
                    this.buttons.radioGetRos.disabled();
                    $('#getros-btn').prop('title', 'Base station must be downlink enabled');
                }

                // VLNA graph
                if ($('#vlna-monitoring-container').length) {
                    this.vlna = new DiagnosticMonitoring(['diagnostic'], 'vlna-monitoring-container', {
                        'keys': ['diagnostic'],
                        'labels': ['VLNA']
                    }, false, {
                        ylabel: 'Voltage (V)',
                        xlabel: 'Time (H:m)'
                    });
                    this.vlna.values.step = (this.options.step / 1000);
                }

                // Tap mean spec graph
                this.tapMeanSpec = new DiagnosticMonitoring(['diagnostic'], "tap_mean_spec-monitoring-container", {
                    'keys': ['diagnostic'],
                    'labels': ['mean spec']
                }, false, {
                    ylabel: 'Average Power (dBm)',
                    xlabel: 'Time (H:m)'
                });
                this.tapMeanSpec.values.step = (this.options.step / 1000);

                if (this.options.internalAllowed) {
                    // DAc/SAc graph
                    this.dac = new DiagnosticMonitoring(['DAc', 'SAc'], 'dac-sac-monitoring-container', {
                        'keys': ['DAc', 'SAc'],
                        'labels': ['DAc', 'SAc']
                    }, false, {
                        ylabel: 'mRatio (%)',
                        xlabel: 'Time (H:m)',
                        fillGraph: false,
                        stepPlot: false
                    });
                    this.dac.values.step = (this.options.step / 1000);
                }

                var $window = $(window);
                $window.unload($.proxy(function() {
                    this.stop();
                }, this));

                if (this.options.autoStart) {
                    this.start();
                }
            };

            Diagnostic.prototype.stop = function() {
                if (this.ws) {
                    this.ws.close();
                    clearTimeout(this.timer);
                    this.loadingMask.hide();
                }
            };

            Diagnostic.prototype.start = function() {
                this.loadingMask.show();
                this.loadingMaskMode.show();
                this.connect(this.routeUrl);
            };

            Diagnostic.prototype.connect = function(routeUrl) {
                if (!this.ws) {
                    $.ajax({
                        url: routeUrl,
                        success: function(data) {
                            var isSecure = ('https:' == location.protocol);
                            var url = (isSecure ? 'wss://' : 'ws://') + data.host + ':' + (isSecure ? data.portSsl : data.port) + '/ws/diagnostic/' +
                                    this.options.tapHexId;
                            url += '?' + data.cookieKey + '=' + data.cookieValue;
                            this.ws = new WebSocket(url, this.protocol);
                            this.ws.onopen = $.proxy(this.onWsOpen, this);
                            this.ws.onmessage = $.proxy(this.onWsMessage, this);
                            this.ws.onclose = $.proxy(this.onWsClose, this);
                            this.ws.onerror = $.proxy(this.onWsError, this);
                        },
                        error: function(event, jqXHR) {
                            this.loadingMaskMode.show();
                            messages.error('An error has occurred, try again in 5s');
                            this.reConnect(5000);
                        },
                        context: this,
                        cache: false,
                        dataType: 'json',
                        crossDomain: true,
                        xhrFields: {
                            withCredentials: true
                        }
                    });
                }
            };

            Diagnostic.prototype.onWsOpen = function() {};

            Diagnostic.prototype.onWsMessage = function(message) {
                if (message.data && message.data.length > 0) {
                    clearTimeout(this.timer);
                    if (this.started) {
                        this.loadingMask.hide();
                    }
                    this.timer = setTimeout($.proxy(function() {
                        this.loadingMask.show();
                    }, this), 20000);

                    var msg = $.parseJSON(message.data);
                    switch (msg.key) {
                        case 'RADIO_FREQ':
                            if (msg.args[0]) {
                                this.buttons.radioFreq.success();
                                if (this.options.waterfall) {
                                    this.options.waterfall.setBaseFrequency(this.baseFreq);
                                }
                            } else {
                                this.buttons.radioFreq.error(msg.args[1]);
                            }
                            break;
                        case 'RADIO_PREAMP1':
                            if (msg.args[0]) {
                                this.buttons.radioPreamp1.success();
                            } else {
                                this.buttons.radioPreamp1.error(msg.args[1]);
                            }
                            break;
                        case 'RADIO_PREAMP2':
                            if (msg.args[0]) {
                                this.buttons.radioPreamp2.success();
                            } else {
                                this.buttons.radioPreamp2.error(msg.args[1]);
                            }
                            break;
                        case 'REBOOT_GATEWAY':
                            if (msg.args[0]) {
                                this.buttons.rebootGateway.success();
                            } else {
                                this.buttons.rebootGateway.error(msg.args[1]);
                            }
                            break;
                        case 'RADIO_HOPPING':
                            if (msg.args[0]) {
                                this.buttons.radioHopping.success();
                                if ($('.hopping-btn-args').first().val() === 'true') {
                                    this.startHopping();
                                } else {
                                    this.stopHopping();
                                }
                            } else {
                                this.buttons.radioHopping.error(msg.args[1]);
                            }
                            break;
                        case 'RADIO_LNA':
                            if (msg.args[0]) {
                                this.buttons.radioLna.success();
                                var elem = $(this.buttons.radioLna.buttonSelector);
                                if (elem.text().indexOf('Start') > -1) {
                                    elem.text(elem.text().replace('Start', 'Stop'));
                                    $('.lna-btn-args').first().val('false');
                                } else {
                                    elem.text(elem.text().replace('Stop', 'Start'));
                                    $('.lna-btn-args').first().val('true');
                                }
                            } else {
                                this.buttons.radioLna.error(msg.args[1]);
                            }
                            break;
                        case 'RADIO_GETROS':
                            if (msg.args[0]) {
                                this.buttons.radioGetRos.success();
                                var button = $('.getros-btn-value');
                                if (msg.args[1] > -9999) {
                                	button.eq(0).text(msg.args[1].toFixed(2));
                                } else {
                                	button.eq(0).text('N/A');
                                }
                                if (msg.args[2] > -9999) {
                                	button.eq(1).text(msg.args[2].toFixed(2));
                                } else {
                                	button.eq(1).text('N/A');
                                }
                                if (msg.args[3] > -9999) {
                                	button.eq(2).text(msg.args[3].toFixed(2));
                                } else {
                                	button.eq(2).text('N/A');
                                }
                                var status = $('#getros-btn-status');
                                if (msg.args[1] > -9999 && msg.args[2] > -9999) {
                                    var returnLoss = 20 * Math.log10( msg.args[1] / msg.args[2] );
                                    button.eq(3).text(returnLoss.toFixed(2));
                                    if (returnLoss < 4.4) {
                                        status.removeClass('gray green');
                                        status.addClass('red');
                                    } else {
                                        status.removeClass('gray red');
                                        status.addClass('green');
                                    }
                                } else {
                                    button.eq(3).text('N/A');
                                    status.removeClass('green red');
                                    status.addClass('gray');
                                }
                                if (msg.args[4] > -9999) {
                                	button.eq(4).text(msg.args[4].toFixed(2));
                                } else {
                                	button.eq(4).text('N/A');
                                }
                                if (msg.args[5] > -9999) {
                                	button.eq(5).text(msg.args[5].toFixed(2));
                                } else {
                                	button.eq(5).text('N/A');
                                }
                            } else {
                                this.buttons.radioGetRos.error(msg.args[1]);
                            }
                            break;
                        case 'GET':
                            // [ ok, time, vlna, mspec, DAc, SAc, hasWriter]
                            if (msg.args[0]) {
                                if (this.vlna) {
                                    var miss = Math.round(((msg.args[1] / 1000) - this.vlna.values.lastTime) / this.vlna.values.step) - 1;
                                    for (var i = 0; i < miss; i++) {
                                        this.vlna.values.data.diagnostic.shift();
                                        this.vlna.values.data.diagnostic.push(NaN);
                                    }
                                    this.vlna.values.lastTime = msg.args[1] / 1000;
                                    this.vlna.values.data.diagnostic.shift();
                                    this.vlna.values.data.diagnostic.push(msg.args[2] >= 0 ? msg.args[2] : NaN);
                                    this.vlna.loadData();
                                }
                                
                                if (msg.args.length > 4 && this.options.internalAllowed) {
                                    //DAc SAc
                                    for (var i = 0; i < miss; i++) {
                                        this.dac.values.data.DAc.shift();
                                        this.dac.values.data.DAc.push(NaN);
                                        this.dac.values.data.SAc.shift();
                                        this.dac.values.data.SAc.push(NaN);
                                    }
                                    this.dac.values.lastTime = msg.args[1] / 1000;
                                    this.dac.values.data.DAc.shift();
                                    this.dac.values.data.DAc.push(msg.args[4] >= 0 ? msg.args[4] : NaN);
                                    this.dac.values.data.SAc.shift();
                                    this.dac.values.data.SAc.push(msg.args[5] >= 0 ? msg.args[5] : NaN);
                                    this.dac.loadData();
                                }
                                
                                if (this.options.isCorrectionNeeded && parseFloat(msg.args[3]) > 0 || !this.options.isCorrectionNeeded &&  parseFloat(msg.args[3]) < -1) {
                                    this
                                    var meanSpec;
                                    if (!this.options.isPsdr) {
                                        meanSpec = 10 * Math.log(msg.args[3]) / Math.LN10;
                                    } else if (this.options.isCorrectionNeeded) {
                                        meanSpec = 10 * Math.log(msg.args[3]) / Math.LN10 + this.options.meanSpecSup;
                                    } else {
                                        meanSpec = msg.args[3];
                                    }
                                    miss = Math.round(((msg.args[1] / 1000) - this.tapMeanSpec.values.lastTime) / this.tapMeanSpec.values.step) - 1;
                                    for (var j = 0; j < miss; j++) {
                                        this.tapMeanSpec.values.data.diagnostic.shift();
                                        this.tapMeanSpec.values.data.diagnostic.push(NaN);
                                    }
                                    this.tapMeanSpec.values.lastTime = msg.args[1] / 1000;
                                    this.tapMeanSpec.values.data.diagnostic.shift();
                                    this.tapMeanSpec.values.data.diagnostic.push(meanSpec);
                                    this.tapMeanSpec.loadData();
                                    // hopping tap mean spec graph
                                    if ($(this.buttons.radioHopping.buttonSelector).children(".icon-spinner").length > 0) {
                                        var index = Math
                                                .floor((this.baseFreq - this.hoppingMeanSpec.values.start) / this.hoppingMeanSpec.values.step);
                                        this.hoppingMeanSpec.values.count[index]++;

                                        if (!this.options.isPsdr) {
                                            this.hoppingMeanSpec.values.linearSum[index] += msg.args[3];
                                            this.hoppingMeanSpec.values.data.averageMeanSpec[index] = 10 * Math.log(this.hoppingMeanSpec.values.linearSum[index] / this.hoppingMeanSpec.values.count[index]) / Math.LN10;
                                        } else if (this.options.isCorrectionNeeded) {
                                            this.hoppingMeanSpec.values.linearSum[index] += msg.args[3];
                                            this.hoppingMeanSpec.values.data.averageMeanSpec[index] = 10 *
                                            Math.log(this.hoppingMeanSpec.values.linearSum[index] / this.hoppingMeanSpec.values.count[index]) /
                                            Math.LN10 + this.options.meanSpecSup;
                                        } else {
                                            this.hoppingMeanSpec.values.linearSum[index] += Math.pow(10, msg.args[3] / 10);
                                            this.hoppingMeanSpec.values.data.averageMeanSpec[index] = 10 * Math.log(this.hoppingMeanSpec.values.linearSum[index] / this.hoppingMeanSpec.values.count[index]) / Math.LN10;
                                        }

                                        this.hoppingMeanSpec.values.data.minMeanSpec[index] = isNaN(this.hoppingMeanSpec.values.data.minMeanSpec[index]) ? meanSpec
                                                : Math.min(meanSpec, this.hoppingMeanSpec.values.data.minMeanSpec[index]);
                                        this.hoppingMeanSpec.values.data.maxMeanSpec[index] = isNaN(this.hoppingMeanSpec.values.data.maxMeanSpec[index]) ? meanSpec
                                                : Math.max(meanSpec, this.hoppingMeanSpec.values.data.maxMeanSpec[index]);
                                        this.hoppingMeanSpec.loadData();
                                    }
                                }
                                if (!msg.args[6]) {
                                    this.loadingMaskMode.hide();
                                } else if (!this.started) {
                                    this.loadingMaskMode.show();
                                }
                            } else {
                                messages.error(msg.args[1]);
                            }
                            break;
                        case 'UPDATE_FREQ':
                            if (msg.args[0] > 0) {
                                if (this.options.waterfall) {
                                    this.options.waterfall.setBaseFrequency(msg.args[0]);
                                    this.baseFreq = msg.args[0];
                                }
                                // if hopping and freq set to stop freq, then end hopping
                                if ($(this.buttons.radioHopping.buttonSelector).children(".icon-spinner").length > 0 &&
                                        msg.args[0] == $('.hopping-btn-args').eq(2).val()) {
                                    this.hoppingEnding = true;
                                } else if (this.hoppingEnding) {
                                    this.hoppingEnding = false;
                                    this.stopHopping();
                                }
                            }
                            break;
                        case 'start_daemon':
                            if (!msg.args[0]) {
                                this.refresh = false;
                                this.ws.close();
                                this.loadingMask.show();
                                this.loadingMaskMode.show();
                                var waterfall = this.options.waterfall;
                                if (waterfall) {
                                    waterfall.refresh = false;
                                    waterfall.ws.close();
                                    waterfall.loadingMask.show();
                                }
                                messages.error(msg.args[1]);
                            }
                            break;
                        case 'SETMODE':
                            if (msg.args[0]) {
                                if (!this.started) {
                                    this.startDiagnostic();
                                } else {
                                    this.stopDiagnostic();
                                }
                            } else {
                                this.startErrorDiagnostic();
                                messages.error(msg.args[1] + ' already diagnose this base station');
                            }
                            break;
                        case 'error':
                            if (!msg.args[0]) {
                                messages.error(msg.args[1]);
                                this.loadingMaskMode.show();
                            }
                            break;
                        default:
                            break;
                    }
                }
            };

            Diagnostic.prototype.onWsClose = function(event) {
                this.ws = null;
                if (this.refresh) {
                    this.reConnect(5000);
                }
            };

            Diagnostic.prototype.onWsError = function(event) {
                messages.error('An error has occurred, try again in 5s');
            };

            Diagnostic.prototype.reConnect = function(delay) {
                // Try to reconnect
                window.setTimeout($.proxy(function() {
                    this.connect(this.routeUrl);
                }, this), delay);
            };

            Diagnostic.prototype.startHopping = function() {
                $(this.buttons.radioHopping.buttonSelector).append(' <i class="icon-spinner icon-spin icon-large"></i>');
                $("#hopping-btn-validate .btn-icon").text(' Stop');
                $('.hopping-btn-args').prop('disabled', true);
                $('.hopping-btn-args').first().val('false');
                this.buttons.radioFreq.disabled();
                this.buttons.radioLna.disabled();
                this.buttons.radioGetRos.disabled();

                var args = $('.hopping-btn-args').map(function(idx, elem) {
                    return $(elem).val();
                }).get();
                this.baseFreq = args[1];
                this.hoppingMeanSpec = new DiagnosticHoppingMonitoring(args, "sweep_mean_spec-monitoring-container", {
                    'keys': ['minMeanSpec', 'averageMeanSpec', 'maxMeanSpec'],
                    'labels': ['min mean spec', 'average mean spec', 'max mean spec']
                }, false, {
                    ylabel: 'Average Power (dBm)',
                    xlabel: 'Frequency (Hz)'
                });
            };

            Diagnostic.prototype.stopHopping = function() {
                $(this.buttons.radioHopping.buttonSelector).children(".icon-spinner").remove();
                $("#hopping-btn-validate .btn-icon").text(' Start');
                $('.hopping-btn-args').prop('disabled', false);
                $('.hopping-btn-args').first().val('true');
                this.buttons.radioFreq.ready();
                this.buttons.radioLna.ready();
                if (this.options.downlinkEnabled) {
                    this.buttons.radioGetRos.ready();
                }
            };

            Diagnostic.prototype.startDiagnostic = function() {
                this.started = true;
                this.buttons.startDiagnostic.success();
                var elem = $(this.buttons.startDiagnostic.buttonSelector);
                $('button#diagnostic-start').toggleClass('started');
                elem.text(elem.text().replace('Start', 'Stop'));
                this.loadingMaskMode.attach();
                this.loadingMask.hide();
            };         


            Diagnostic.prototype.startErrorDiagnostic = function() {
                this.started = false;
                this.buttons.startDiagnostic.error();
                var elem = $(this.buttons.startDiagnostic.buttonSelector);
                elem.text(elem.text().replace('Stop', 'Start'));
                this.loadingMaskMode.attach();
                this.loadingMask.show();
            };

            Diagnostic.prototype.stopDiagnostic = function() {
                this.started = false;
                this.buttons.startDiagnostic.success();
                var elem = $(this.buttons.startDiagnostic.buttonSelector);
                $('button#diagnostic-start').toggleClass('started');
                elem.text(elem.text().replace('Stop', 'Start'));
                // reinit values
                // hopping
                this.stopHopping();
                // bypass lna
                elem = $(this.buttons.radioLna.buttonSelector);
                elem.text(elem.text().replace('Stop', 'Start'));
                $('.lna-btn-args').first().val('true');
                // close all sub forms
                $('.btn-form').slideUp();
                this.loadingMaskMode.attach();
                this.loadingMask.show();
            };
            return Diagnostic;
        });
